import { mapGetters } from 'vuex'
import ActionButton from '@/components/ActionButton'
import Message from '@/components/SignupInfoMessage'
import ProgressBar from '@/components/ProgressBar'
export default {
  name: 'SignupKycStep1',
  components: { ActionButton, Message, ProgressBar },
  props: [],
  data () {
    return {
      incorrectDateFormat: false,
      incorrectPAN: false,
      message: {
        value: undefined,
        type: undefined,
        className: undefined,
        fieldName: undefined,
        actions: undefined,
        showModal: undefined
      },

    }
  },
  computed: {
    ...mapGetters({
      user: 'userDetails',
      appliedToDmi: 'appliedToDmi',
      invalidPinCode: 'invalidPersonalPinCode',
      disablePanField: 'disablePanField'
    })
  },
  beforeRouteEnter (to, from, next) {
    next(() => {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "KYC_EMPLOYMENT_DETAILS_SUBMITTED",
        propertyName: "STARTING_POINT",
        propertyValue: from.name ? from.name.toUpperCase() : 'OTHER'
      });
    })
  },
  mounted () {

    this.getUserDetails()
  },
  methods: {
    getUserDetails () {
      const self = this
      this.$store.dispatch('userDetails').then(response => {
        self.$store.dispatch("storeMixpanelEvent", {
          eventName: "KYC_STARTED",
          propertyName: "CL",
          propertyValue: response.originalCreditLimit
        });
      })
    },
    startDMI () {
      if (!this.incorrectDateFormat && !this.invalidPinCode) {
        this.$router.push({ name: 'KYC Step 2' })
      }
    },
    getPinCodeDetails (personal, pincode = '') {
      if (this.invalidPinCode) {
        this.$store.commit('invalidPinCode', {
          status: false,
          personal: personal
        })
      }
      if (pincode.length === 6) {
        this.$store.dispatch('pinCode', { pincode, personal })
      }
    },
    validateDate (event) {
      if (event.inputType.indexOf("delete") < 0) {
        this.incorrectDateFormat = false
        const regex = new RegExp('^([0-9]{2}/[0-9]{4})$')
        if (this.user.employmentDetail.workingSince.length === 2) {
          this.user.employmentDetail.workingSince += '/'
        }
        if (this.user.employmentDetail.workingSince.length === 7) {
          if (
            !(
              parseInt(this.user.employmentDetail.workingSince.slice(0, 2)) <=
              12 &&
              this.user.employmentDetail.workingSince.slice(3, 7) <=
              new Date().getFullYear() &&
              regex.test(this.user.employmentDetail.workingSince)
            )
          ) {
            this.incorrectDateFormat = true
            this.message = {
              value: "Please enter date in correct format",
              type: "error",
              className: "message--error",
            };
          }
          else {
            this.message = undefined
          }
        }
      }
    },
    validatePAN () {
      this.incorrectPAN = false
      this.user.pan = this.user.pan.toUpperCase()
      const regex = new RegExp('^([a-zA-Z]{5}[0-9]{4}[a-zA-Z])$')
      if (this.user.pan.length === 10 && !regex.test(this.user.pan)) {
        this.incorrectPAN = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SignupKycStep1/component.js